import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";
import { AppLanguage, toAppLanguage, writeLanguageOverride } from "@/utilities/language";

/**
 * The language of the page, with the English original one click away.
 *
 * Without a pick the app follows the user's Geotab account; picking here overrides it for as long
 * as the tab is open, page changes included. Nobody has to edit their account to look at the
 * values under the names the vehicles report them by.
 */
export default function LanguageToggle() {
  const { i18n } = useTranslation();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      // Reduced to the two the buttons carry: an account set to "de-DE" matches neither, and the
      // pair would look as though nothing were selected at all.
      value={toAppLanguage(i18n.language) ?? "de"}
      onChange={(_e, lng: AppLanguage | null) => {
        if (!lng) return;
        i18n.changeLanguage(lng);
        writeLanguageOverride(lng);
      }}
      sx={{
        height: 28,
        "& .MuiToggleButton-root": {
          px: 1,
          fontSize: "0.75rem",
          color: "inherit",
          borderColor: "rgba(255,255,255,0.4)",
          "&.Mui-selected": {
            bgcolor: "rgba(255,255,255,0.2)",
            color: "inherit",
            "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
          },
          "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
        },
      }}
    >
      <ToggleButton value="de">DE</ToggleButton>
      <ToggleButton value="en">EN</ToggleButton>
    </ToggleButtonGroup>
  );
}
